export default __webpack_public_path__ + "static/photo-bar-7-04699944a85782e5885e506d3e3a8b7f.jpg";